exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".drop_zone{position:fixed;top:0;bottom:0;left:0;right:0;z-index:99999;background-color:hsla(0,0%,100%,.5);text-align:center;padding-top:70px;font-size:2em}", "", {"version":3,"sources":["C:/Users/fpluq/Projects/groopus-vue/src/tools/Dropzone.vue"],"names":[],"mappings":"AACA,WACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,oCAA2C,AAC3C,kBAAmB,AACnB,iBAAkB,AAClB,aAAe,CAChB","file":"Dropzone.vue","sourcesContent":["\n.drop_zone {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 99999;\n  background-color: rgba(255, 255, 255, 0.5);\n  text-align: center;\n  padding-top: 70px;\n  font-size: 2em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d0ac81b","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/Dropzone.vue
// module id = 970
// module chunks = 2 6